import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import {
  Title,
  Subtitle,
  Panel,
  ScrollBox,
} from '..';

const AnimatedFlex = styled(Flex)`
  transition: ${(props) => props.theme.animation.slow};
`;

const List = styled(Box)`
  max-height: 422px;
  overflow: auto;
`;

function PolicyManagementSection(props) {
  const {
    policyList,
    policyDetail,
    listHeader,
    detailHeader,
    isEditing,
    addPolicyButton,
    searchInput,
    resultsEmpty,
    policyLength,
  } = props;

  return (
    <Box pb={5} height="100%">
      <Flex mb={5} height="36px" justifyContent="space-between">
        {addPolicyButton}
        {searchInput}
      </Flex>
      {!searchInput ? resultsEmpty : null}
      <Flex sx={{
        height: policyLength > 0 ? 'calc(100% - 36px)' : '',
      }}
      >
        <AnimatedFlex height="100%" flex={1} mr={2} flexDirection="column">
          {listHeader && <Flex mb={3}>{listHeader}</Flex>}
          <ScrollBox pr={3}>
            {policyList}
          </ScrollBox>
        </AnimatedFlex>
        <AnimatedFlex height="100%" flex={isEditing ? 4 : [1, 1, 1, 2]} ml={2} flexDirection="column">
          {detailHeader && (
            <Box mb={3}>
              {detailHeader}
            </Box>
          )}
          {policyDetail && (
            <ScrollBox>
              <Panel ml={2}>
                {policyDetail}
              </Panel>
            </ScrollBox>
          )}
        </AnimatedFlex>
      </Flex>
      {searchInput ? resultsEmpty : null}
    </Box>
  );
}

PolicyManagementSection.defaultProps = {
  listHeader: undefined,
  detailHeader: undefined,
  policyDetail: undefined,
  policyList: null,
  isEditing: false,
  addPolicyButton: null,
  searchInput: null,
  resultsEmpty: null,
  policyLength: 0,
};

PolicyManagementSection.propTypes = {
  policyList: PropTypes.object,
  listHeader: PropTypes.object,
  policyDetail: PropTypes.object,
  detailHeader: PropTypes.object,
  isEditing: PropTypes.bool,
  addPolicyButton: PropTypes.object,
  searchInput: PropTypes.object,
  resultsEmpty: PropTypes.object,
  policyLength: PropTypes.number,
};

export default PolicyManagementSection;
